/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Stats_SubscriptionsInputs */

const he_dashboard_stats_subscriptions = /** @type {(inputs: Dashboard_Stats_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מנויים`)
};

const en_dashboard_stats_subscriptions = /** @type {(inputs: Dashboard_Stats_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscriptions`)
};

/**
* | output |
* | --- |
* | "Subscriptions" |
*
* @param {Dashboard_Stats_SubscriptionsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_stats_subscriptions = /** @type {((inputs?: Dashboard_Stats_SubscriptionsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Stats_SubscriptionsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_stats_subscriptions(inputs)
	return en_dashboard_stats_subscriptions(inputs)
});